import { iconMapping, type IMovementType, type TMovementType, type TMovementTypeGroup } from '../types';
import type { MovementType } from '@/shared/api/experience';

export const mapMovementType = (type: MovementType): IMovementType => {
  return {
    str: type.str as TMovementType,
    label: type.label,
    iconName: type.str ? (iconMapping[type.str as TMovementType & TMovementTypeGroup] ?? null) : null,
    isSelected: false,
    labelPhrase: type?.label_phrase || '',
  };
};
